import React, { useState } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, FormControl, FormLabel, Input, Text, VStack, Alert, AlertIcon, useToast,
} from '@chakra-ui/react';
import { authApi } from '../services/api';

// "Esqueci minha senha": pede o e-mail e dispara o envio do link de redefinição.
const ForgotPasswordModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const close = () => { setEmail(''); setSent(false); onClose(); };

  const submit = async () => {
    if (!email.includes('@')) {
      toast({ title: 'Informe um e-mail válido', status: 'warning', duration: 3000 });
      return;
    }
    setLoading(true);
    try {
      await authApi.forgotPassword(email.trim());
      setSent(true);  // resposta sempre neutra (não revela se o e-mail existe)
    } catch {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={close} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Esqueci minha senha</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {sent ? (
            <Alert status="success" borderRadius="md">
              <AlertIcon />
              Se o e-mail estiver cadastrado, enviamos um link para redefinir a senha. Verifique sua caixa de entrada (e o spam).
            </Alert>
          ) : (
            <VStack align="stretch" spacing={3}>
              <Text fontSize="sm" color="gray.600">
                Informe o e-mail da sua conta. Enviaremos um link para você criar uma nova senha.
              </Text>
              <FormControl isRequired>
                <FormLabel fontSize="sm">E-mail</FormLabel>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com" autoFocus />
              </FormControl>
            </VStack>
          )}
        </ModalBody>
        <ModalFooter>
          {sent ? (
            <Button colorScheme="brand" onClick={close}>Fechar</Button>
          ) : (
            <>
              <Button variant="ghost" mr={3} onClick={close}>Cancelar</Button>
              <Button colorScheme="brand" onClick={submit} isLoading={loading}>Enviar link</Button>
            </>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ForgotPasswordModal;
